import { ButtonLink } from "@/components/Buttons";
import ProcessInformation from "@/components/ProcessInformation";
import { rightViewTerm } from "@/components/RightViewTerm";

import { PAYMENT_METHOD_NAMES } from "@/lib/constants";
import formatPrice from "@/lib/formatPrice";
import routes from "@/lib/routes";
import styles from "@/styles/Payment.module.scss";
import processStyles from "@/styles/Process.module.scss";

export default function PurchaseFormStep3({
  product,
  purchaseData,
  _isSignUp,
}) {
  const price = formatPrice(purchaseData?.order?.payment_amount);
  const paymentMethod = purchaseData?.order?.payment_method_id;
  const [rightLabel, rightText] = rightViewTerm(product?.right);
  const metaId = product?.meta?.id;

  return (
    <ProcessInformation complete header="購入が完了しました">
      <div className={`${styles.container} ${styles.center}`}>
        <div className={styles.section}>
          <div className={styles.sectionLeft}>
            <img src={product.thumbnailUrl} />
          </div>
          <div className={styles.sectionRight}>
            <h4 className={styles.title}>{product.name}</h4>
            <div className={`${styles.info} ${styles.price}`}>
              <div className={styles.left}>金額</div>
              <div className={styles.right}>
                <div>
                  <span className={styles.priceAmount}>{price}円</span>（税込）
                </div>
              </div>
            </div>
            <div className={styles.info}>
              <div className={styles.left}>{rightLabel}</div>
              <div className={styles.right}>{rightText}</div>
            </div>
            <div className={`${styles.info} ${styles.paymentMethod}`}>
              <div className={styles.left}>支払方法</div>
              <div className={styles.right}>
                <div className={styles.paymentMethodName}>
                  {PAYMENT_METHOD_NAMES[paymentMethod]}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={processStyles.btnArea}>
        <ButtonLink href={routes.watch(metaId)} fillColor large>
          {product?.meta?.name}を視聴する
        </ButtonLink>
      </div>
    </ProcessInformation>
  );
}
